export default __webpack_public_path__ + "static/logo-16-99fe268e3189d09d6603125485fae26a.png";